/** Bank account details shown for manual (bank transfer) payment. */
export const MANUAL_BANK_ACCOUNT = {
  companyName: "Sundarban cargo services UK limited",
  accountNumber: "75834260",
  sortCode: "30-99-50",
  bankName: "LLOYDS",
};

/** Existing PaymentTypeMethod id used elsewhere as "Bank Payment". */
export const MANUAL_PAYMENT_TYPE_ID = "5";

const INVOICE_PREFIX = "INV";

/**
 * Client-side provisional invoice number (INV + YYMMDD + 4 digits).
 * Prefer server-generated numbers when the API is available.
 */
export function generateProvisionalInvoiceNumber(date = new Date()) {
  const yy = String(date.getFullYear()).slice(-2);
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const dd = String(date.getDate()).padStart(2, "0");
  const seq = String(Math.floor(Math.random() * 10000)).padStart(4, "0");
  return `${INVOICE_PREFIX}${yy}${mm}${dd}${seq}`;
}

export function formatManualPaymentNote(invoiceNumber) {
  return `Please attach invoice number ${invoiceNumber} in payment reference.`;
}
